/**
 * Cores da marca Kanal Publicidade (extraídas do logo):
 *   teal     #08C4A1  - destaque (fundos de botão, item ativo, gráficos)
 *   marinho  #002D49  - estrutura (menu, textos fortes)
 *   amarelo  #FDBC00  - alertas e contadores
 *
 * Contraste verificado (WCAG): marinho sobre branco 14,3; marinho sobre teal 6,4;
 * teal sobre branco só 2,2 e por isso NUNCA vai em texto sobre fundo claro:
 * para texto colorido sobre claro usamos o teal escuro (#087A67, contraste 5,3).
 *
 * Para trocar a identidade (revenda a outro cliente), edite só `brand`.
 */
const brand = {
  teal: "#08C4A1",
  tealDark: "#087A67",
  tealLight: "#5FE0C6",
  navy: "#002D49",
  navyDeep: "#001F33",
  yellow: "#FDBC00",
};

const palette = {
  light: {
    primary: {
      main: brand.teal,
      dark: brand.tealDark,
      light: brand.tealLight,
      contrastText: brand.navy,
    },
    secondary: {
      main: brand.navy,
      dark: brand.navyDeep,
      contrastText: "#FFFFFF",
    },
    success: { main: "#1B8A5A" },
    error: { main: "#D93F3F" },
    warning: { main: brand.yellow, contrastText: brand.navy },
    text: {
      primary: "#0F2A3D",
      secondary: "#566B7B",
    },
    divider: "rgba(0, 45, 73, 0.10)",
    background: {
      default: "#F1F5F8",
      paper: "#FFFFFF",
      chat: "#E9EFF3",
    },
    action: { selected: "rgba(8, 196, 161, 0.14)", hover: "rgba(0, 45, 73, 0.05)" },
    cards: { background: "#FFFFFF" },
    appBar: { background: "#FFFFFF", text: "#0F2A3D" },
    sidebar: {
      background: brand.navy,
      text: "rgba(255, 255, 255, 0.86)",
      textMuted: "rgba(255, 255, 255, 0.55)",
      hover: "rgba(255, 255, 255, 0.08)",
      activeBackground: brand.teal,
      activeText: brand.navy,
      divider: "rgba(255, 255, 255, 0.12)",
    },
    brand,
    scrollbar: { thumb: "rgba(0, 45, 73, 0.18)" },
    userMessage: { main: "#D3F5EC" },
    contactMessage: { main: "#FFFFFF" },
    timestamp: { background: "#DCE5EB" },
    queue: { fallback: "#7C8E9B" },
  },
  dark: {
    primary: {
      main: brand.teal,
      dark: brand.tealDark,
      light: brand.tealLight,
      contrastText: brand.navy,
    },
    secondary: {
      main: "#9FB6C6",
      dark: "#7F98AA",
      contrastText: brand.navy,
    },
    success: { main: "#3FD08F" },
    error: { main: "#FF6B6B" },
    warning: { main: brand.yellow, contrastText: brand.navy },
    text: {
      primary: "#E8F1F6",
      secondary: "#9FB3C2",
    },
    divider: "rgba(255, 255, 255, 0.10)",
    background: {
      default: "#06192A",
      paper: "#0B2437",
      chat: "#071D2F",
    },
    action: { selected: "rgba(8, 196, 161, 0.20)", hover: "rgba(255, 255, 255, 0.06)" },
    cards: { background: "#0F2E45" },
    appBar: { background: "#0B2437", text: "#E8F1F6" },
    sidebar: {
      background: "#04131F",
      text: "rgba(255, 255, 255, 0.86)",
      textMuted: "rgba(255, 255, 255, 0.55)",
      hover: "rgba(255, 255, 255, 0.08)",
      activeBackground: brand.teal,
      activeText: brand.navy,
      divider: "rgba(255, 255, 255, 0.10)",
    },
    brand,
    scrollbar: { thumb: "rgba(255, 255, 255, 0.18)" },
    userMessage: { main: "#0C5C50" },
    contactMessage: { main: "#12354F" },
    timestamp: { background: "#0F2E45" },
    queue: { fallback: "#7C8E9B" },
  },
};

export default palette;
